import { Box } from '@mui/material';

type Props = {
    icon: string;
    description?: string;
};

export const WeatherIcon = ({ icon, description }: Props) => (
    <Box
        component="img"
        src={icon}
        srcSet={`${icon} 1x, ${icon.replace('_small.png', '_small@2x.png')} 2x`}
        alt={description ?? ''}
        title={description}
        sx={{ width: 24, height: 24, flexShrink: 0 }}
    />
);
